
$( document ).ready(function() {

  /*  Gestion du champ reherche
      Si on arret de la saisie declenchement
      Si champ entrée declenchement
   */
   var typingTimer;                //timer identifier
   var doneTypingInterval = 3000;
   //let formInitialState = $('#form-search-carenews').serialize();
   let formInitialState = getFormState();


/*
  $('#form-search-carenews').bind('click', function (e) {

    let newFormState = $('#form-search-carenews').serialize();
    if(newFormState != formInitialState) {
      $('.listing__wrapper').css('opacity' , '0.3');
      $('.lds-dual-ring').css('display' , 'inline-block');
     // $('#form-search-carenews').submit();
    }
  });*/

  var $input = $('.special-search__input input');
  $input.on('keyup', function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  });

//on keydown, clear the countdown
  $input.on('keydown', function () {
    clearTimeout(typingTimer);
  });

  function doneTyping () {
    $('#form-search-carenews').submit();
  }

  $(document).keypress(function(e){
    if (e.which == 13){
      $('#form-search-carenews').submit();
    }
  });

  /*  FIN CHAMP RECHERCHE */

  function checkFormVariation(formInitialState)
  {
    //let newFormState = $('#form-search-carenews').serialize();
    let newFormState = getFormState();
    if(newFormState != formInitialState) {
      $('.listing__wrapper').css('opacity' , '0.3');
      $('.lds-dual-ring').css('display' , 'inline-block');
      $('#form-search-carenews').submit();
    }
  }

  function getFormState()
  {
    let formState = $('#form-search-carenews :input').filter(function(index, element) {
      return $(element).attr("name") != 'recherche';
    }).
    serialize();
    return formState;
  }

  window.setInterval(function(){
    checkFormVariation(formInitialState);
  }, 5000);




  $("#searchAlertButton").bind("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $.ajax({
      url: "/ajax/is-connected",
      context: document.body
    }).done(function( response ) {

      let data = jQuery.parseJSON(response);
      if(!data.is_logged)
      {
        $('#connection-required').modal('show');
      }
      else
      {

        if($('#emptyFilterCheck').val() == 1)
        {
          $('#alertes-mails .modal-body').hide();
          $('#alertes-mails #modal-body-no-filter').show();
        }

        console.log($('#critereText').html());
        $('#popin-alerte-criteres').html($('#critereText').html()) ;

        $('#alertes-mails').modal('show');



      }
    });
  });

  $("#searchAlertButtonValidate").bind("click", function (e) {

    e.preventDefault();
    e.stopPropagation();
    let $formSearchType = $('#formSearchType').val();

    $.ajax({
      url: "/ajax/add-alerte",
      method : "POST",
      data : {type : $formSearchType , data : $('#form-search-carenews').serialize() , 'alerteName' : $('#alerteName').val() },
      context: document.body
    }).done(function( dataAlerte ) {



      $('#alertes-mails .modal-body').hide();
      $('#alertes-mails #modal-body-alerte-add-success').show();

      setTimeout(function(){ $('#alertes-mails').modal('hide');
        $('#alertes-mails .modal-body').hide();
        $('#alertes-mails #modal-body-add-alerte').show();
      }, 3000);

    });

  });



  $(".add_alerte_acteur").bind("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    let $current = $(e.currentTarget);
    window.actorNodeID = $current.data("actor_node_id");


    $.ajax({
      url: "/ajax/is-connected",
      context: document.body
    }).done(function( response ) {

      let data = jQuery.parseJSON(response);
      if(!data.is_logged)
      {
        $('#connection-required').modal('show');
      }
      else
      {
        $('#alertes-acteurs-mails').modal('show');
        $('#alertes-acteurs-mails #alerteActorName').val( $current.data("actor_node_name"));
      }
    });
  });
  $("#AlertActeurButtonValidate").bind("click", function (e) {

    e.preventDefault();
    e.stopPropagation();

    //console.log( 'roberto' + $('#alerteActorName').val());

    $.ajax({
      url: "/ajax/add-alerte",
      method : "POST",
      data : {type : 'Acteur' , data :  "acteur="+actorNodeID, 'alerteName' : $('#alerteActorName').val()  },
      context: document.body
    }).done(function( dataAlerte ) {
      $('#alertes-acteurs-mails .modal-body .info').css('display' , 'none');
      $('#alertes-acteurs-mails .modal-body .resultAjax').css('display' , 'block');
      $('#alertes-acteurs-mails .modal-body .resultAjax').html('Votre alerte a été ajoutée');
      setTimeout(function(){

        $('#alertes-acteurs-mails').modal('hide');
        $('#alertes-acteurs-mails .modal-body .info').css('display' , 'block');
        $('#alertes-acteurs-mails .modal-body .resultAjax').css('display' , 'none');

        }, 3000);
    });

  });

  /* modal publications restreintes */
  $(".button_publication_restreinte").bind("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('#modal-publication-restreinte').modal('show');
  });

  /* modal publications restreintes */
/*  $("#modal-publication-restreinte-submit-button").bind("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
*/

    $( "#modal-publication-restreinte-form" ).submit(function( event ) {


        var formData = {
          nom: $("#modal-publication-restreinte input[name='nom'] ").val(),
          prenom: $("#modal-publication-restreinte input[name='prenom'] ").val(),
          structure: $("#modal-publication-restreinte input[name='structure'] ").val(),
          email: $("#modal-publication-restreinte input[name='email'] ").val(),
          publicationID: $("#modal-publication-restreinte input[name='publicationID'] ").val(),
        };

        $.ajax({
          type: "POST",
          url: "/publication-download",
          data: formData,
          dataType: "json",
          encode: true,
        }).done(function (data) {

          console.log(data);

          var html = "Merci pour votre engagement ! <br/>Bonne lecture ! <br/><br/> <center><a target='_blank' class=\"btn btn-secondary\" href='"+ data.data.downloadLink + "'>Télécharger</a></center>";
          $('#modal-publication-restreinte .modal-body').html(html);

          console.log(html);
        });

        event.preventDefault();

    });


   // });






});
